import React from 'react'
import { DropDown } from '../../../commons'
import { countryCode } from '../../../../constant/countryCode'
import { InputDetailsErrorType } from '..';
import { STATES_LIST } from '../../../../constant/stateListConstants';
import { DropDownItemType } from '../../../../screens/TimeSheet';
import Select from "react-select";

type AppProps = {
    postalAddress: any;
    setClientBasicDetails: (data: any) => void
    inputDetailsError: InputDetailsErrorType;
    setInputDetailsError: (data: any) => void;
    isDisabled?:boolean;
    onMenuClose:any;
    Option:any;
    countrySelectedList:any;
    countryFetching:any;
    setLoadCondition:any;
    setCountryText:any;
    setCountryOffset:any;
    handleChangeCountry:any;
    countryLimit:any
    postalAddressDropDownValue:any
    handleChangeState:(data:any)=>void;
    finalStateList:any;
    stateFetching:boolean;
    setStateOffset:any;
    setStateText:any;
    isState:null | boolean;
    isCity:null | boolean;
    finalCityList:any;
    handleChangeCity:(data:any)=>void;
    setCityOffset:any;
    setCityText:any;
    cityLimit:number;
    setCityLimit:any;
    stateLimit:number;


}
const PostalAddress = ({
    postalAddress,
    setClientBasicDetails,
    inputDetailsError,
    setInputDetailsError,
    isDisabled,
    onMenuClose,
    Option,
    countrySelectedList,
    countryFetching,
    setLoadCondition,
    setCountryText,
    setCountryOffset,
    handleChangeCountry,
    countryLimit,
    postalAddressDropDownValue,
    handleChangeState,
    finalStateList,
    stateFetching,
    setStateOffset,
    setStateText,
    isState,
    isCity,
    finalCityList,
    handleChangeCity,
    setCityOffset,
    setCityText,
    cityLimit,
    setCityLimit,
    stateLimit


}: AppProps) => {

    const checkBottom = (e: any) => {
        setLoadCondition(false);
    
        setCountryOffset((prv: any) => prv + countryLimit);
      };
      const checkBottomState = (e: any) => {
        setLoadCondition(false);
        setStateOffset((prv: any) => prv + stateLimit);
      };
    const checkBottomCity = (e: any) => {
        setLoadCondition(false);
        setCityOffset((prv: any) => prv + cityLimit);
      };
    const countryDropdown = countryCode?.map((e: any) => {
        return {
            value: e.name,
            label: e.name
        }
    })

    const handlePostalAddressChange = (data: any) => {
        setClientBasicDetails((prev: any) => {
            return {
                ...prev,
                postalAddress: {
                    ...prev.postalAddress,
                    [data.target.name]: data.target.value
                }
            }
        })
    }

    const handleCountryDropDown = (data: { value: string, label: string }) => {
        if (data?.value) {
            setInputDetailsError((prev: any) => {
                return {
                    ...prev,
                    countryError: ""
                }
            })
        }
        setClientBasicDetails((prev: any) => {
            return {
                ...prev,
                postalAddress: {
                    ...prev.postalAddress,
                    country: {
                        value: data.value,
                        label: data.label
                    }
                }
            }
        })
    }

    const handleStateChange=(data:DropDownItemType)=>{
        setClientBasicDetails((prev: any) => {
            return {
                ...prev,
                postalAddress: {
                    ...prev.postalAddress,
                    state: {
                        value: data.value,
                        label: data.label
                    }
                }
            }
        })
    }

    return (
        <>
            <div className='row'>
                <div className="col-md-6">
                    <label htmlFor="addressLine1">Address Line 1 </label>
                    <div >
                        <input
                            type="textArea"
                            className={`form-control`}
                            name="addressLine1"
                            onChange={handlePostalAddressChange}
                            value={postalAddress?.addressLine1}
                            disabled={isDisabled}
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <label htmlFor="addressLine2">Address Line 2</label>
                    <div >
                        <input
                            type="textArea"
                            className={`form-control`}
                            name="addressLine2"
                            onChange={handlePostalAddressChange}
                            value={postalAddress?.addressLine2}
                            disabled={isDisabled}
                        />
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className="col-md-3 mt-3">
                    <label htmlFor="address">Address</label>
                    <div >
                        <input
                            type="text"
                            className="form-control"
                            name="address"
                            onChange={handlePostalAddressChange}
                            value={postalAddress?.address}
                            disabled={isDisabled}
                        />
                    </div>
                </div>
              
                  <div className="col-md-3 mt-3">
                    <label htmlFor="postalCode">Postal Code</label>
                    <div >
                        <input
                            type="text"
                            className="form-control"
                            name="postalCode"
                            onChange={handlePostalAddressChange}
                            value={postalAddress?.postalCode}
                            disabled={isDisabled}
                        />
                    </div>
                </div>
            </div>
            <div className='row'>
                 <div className='col-md-3 mt-3'>
                    <label htmlFor='country'>Country <span className='color-red'>*</span></label>
                      <Select
                  onMenuClose={onMenuClose}
                  components={{ Option }}
                  isSearchable={true}
                  options={countrySelectedList}
                  isLoading={countryFetching}
                  className={`${inputDetailsError?.countryError ? "error-border rounded" : ""}`}
                  value={postalAddressDropDownValue?.country}
                  onMenuScrollToBottom={(e: any) => checkBottom(e)}
                  onChange={(e) => {handleChangeCountry(e)
                    handleChangeState(null);
                    handleChangeCity(null);
                  }
                  }
                  onInputChange={(e) => {
                    setLoadCondition(false);
                    setCountryText(e);
                    setCountryOffset(0);
                  }}
                  isDisabled={isDisabled}

                />
                    {!!inputDetailsError?.countryError && (
                        <small className="text-danger">{inputDetailsError?.countryError}</small>
                    )}
                </div>
                {postalAddressDropDownValue?.country?.value && isState && (
          <div className="col-md-4 mt-3">
            <form>
              <div>
                <div>
                  {isState && (
                    <label
                      htmlFor="State"
                      className={ "active"}
                    >
                      State <span className="color-red">*</span>
                    </label>
                  )}
                  {isState && (
                    <Select
                      onMenuClose={onMenuClose}
                      components={{ Option }}
                      isSearchable={true}
                      options={finalStateList}
                      className={`${inputDetailsError?.stateError ? "error-border rounded" : ""}`}
                      placeholder="Choose state"
                      isLoading={stateFetching}
                      value={
                        postalAddressDropDownValue?.state?.value
                          ?  postalAddressDropDownValue?.state
                          : { label: "Select..", value: null }
                      }
                      onMenuScrollToBottom={(e: any) => checkBottomState(e)}
                      onChange={(e) => {
                        handleChangeState(e);
                        handleChangeCity(null);
                      }}
                      onInputChange={(e) => {
                        setLoadCondition(false);
                        setStateText(e);
                        setStateOffset(0);
                      }}
                      isDisabled={isDisabled}

                    />
                  )}
                </div>
              </div>
            </form>
            {!!inputDetailsError?.stateError && (
                        <small className="text-danger">{inputDetailsError?.stateError}</small>
                    )}
          </div>
        )}
               
                  {((isState === true &&   postalAddressDropDownValue?.state?.value && isCity) ||
          (isState === false && postalAddressDropDownValue?.country?.value && isCity)) && (
      
          <div className="col-md-4 mt-3">
            <form>
              <div>
                <div>
                  <label htmlFor="City" className={"active" }>
                    City <span className="color-red">*</span>
                  </label>

                  <Select
                    onMenuClose={onMenuClose}
                    components={{ Option }}
                    isSearchable={true}
                    options={finalCityList}
                    isLoading={countryFetching}
                    className={`${inputDetailsError?.cityError ? "error-border rounded" : ""}`}
                    value={
                        postalAddressDropDownValue?.city?.value
                        ? postalAddressDropDownValue?.city
                        : { label: "Select..", value: null }
                    }
                    onMenuScrollToBottom={(e: any) => checkBottomCity(e)}
                    onChange={(e) => handleChangeCity(e)}
                    onInputChange={(e) => {
                      setLoadCondition(false);
                      setCityText(e);
                      setCityOffset(0);
                    }}
                    isDisabled={isDisabled}

                  />
                </div>
              </div>
              {!!inputDetailsError?.cityError && (
                        <small className="text-danger">{inputDetailsError?.cityError}</small>
                    )}
            </form>
           
          </div>
        )}
            </div>
        </>
    )
}

export default PostalAddress